import ThemeInterface from '@/theme-interface'

// The dropdowns of the checkout follow the new brand (design "Anrede · Auswahl geöffnet"). Passed as `styles`
// to SelectInput / CountryInput - SelectInput applies them on top of its default react-select styles.

interface ControlState {
  isFocused?: boolean
  isDisabled?: boolean
  selectProps?: { menuIsOpen?: boolean }
}

interface OptionState {
  isSelected?: boolean
  isFocused?: boolean
}

// the menu opens 6 px below the field, as its own card - placed above the field when there is no room below
const MENU_GAP = 6

export const brandSelectStyles = (theme: ThemeInterface) => ({
  control: (base: object, { isFocused, isDisabled, selectProps }: ControlState) => ({
    ...base,
    borderRadius: theme.borderRadiusLarge,
    borderColor: selectProps?.menuIsOpen || isFocused ? theme.palette.brand.main : theme.palette.brand.inputBorder,
    background: isDisabled ? theme.backgroundColor : theme.palette.background.paper,
    '&:hover': {
      borderColor: selectProps?.menuIsOpen || isFocused ? theme.palette.brand.main : theme.palette.brand.text.secondary,
    },
  }),
  valueContainer: (base: object) => ({
    ...base,
    padding: '0 14px',
  }),
  singleValue: (base: object) => ({
    ...base,
    color: theme.palette.brand.text.primary,
  }),
  input: (base: object) => ({
    ...base,
    margin: 0,
    padding: 0,
    color: theme.palette.brand.text.primary,
  }),
  dropdownIndicator: (base: object) => ({
    ...base,
    color: theme.palette.brand.text.primary,
    '&:hover': {
      color: theme.palette.brand.text.primary,
      cursor: 'pointer',
    },
  }),
  menu: (base: object) => ({
    ...base,
    marginTop: MENU_GAP,
    marginBottom: MENU_GAP,
    border: `1px solid ${theme.palette.brand.divider}`,
    borderRadius: theme.borderRadiusLarge,
    background: theme.palette.background.paper,
    boxShadow: theme.shadowCard,
    overflow: 'hidden',
  }),
  menuList: (base: object) => ({
    ...base,
    paddingTop: 8,
    paddingBottom: 8,
  }),
  option: (base: object, { isSelected, isFocused }: OptionState) => {
    let background = 'transparent'
    if (isSelected) background = theme.palette.brand.selected
    else if (isFocused) background = theme.palette.brand.light

    return {
      ...base,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      gap: 8,
      minHeight: 44,
      padding: '10px 16px',
      borderRadius: 0,
      color: theme.palette.brand.text.primary,
      background,
      '&:hover': {
        background: isSelected ? theme.palette.brand.selected : theme.palette.brand.light,
      },
      '&:active': {
        background: theme.palette.brand.selected,
      },
    }
  },
})
